

import React from 'react'
import {ItemProps } from '@/components/Form/types'
import DeleteAbsoluteButton from '@/components/UiElements/DeleteAbsoluteButton'
import FontWrapper from '@/components/FontManager/Components/FontWrapper'
import Alert from '@/components/UiElements/Alert'
import { DraggableSortList } from '@/components/UiElements/DragableSortList'



export default function FontStylesList(props: ItemProps) {


	const data:any = props.formData?.[props.formItem.name] || []
	const hasSelected = data.find((item:any) => item.selected) || null

	const handleDelete = (item: any) => {

		Alert.showAlert({
			title: "Remove Font Style",
			message: (
				<div className={"flex flex-col items-center justify-center "}>
					<div className={"border border-gray-300 p-xl rounded-md my-md !text-[54px] capitalize"}>
						<FontWrapper item={item}>
							{item.name}
						</FontWrapper>
					</div>
					Are you sure you want to remove this font style?
				</div>
			),

			isCancelable: true,
			button: "Confirm & Remove",
			danger: true,
			callBack: async (ok) => {
				if (ok) {
					const newData = data.filter((i: any) => i.id !== item.id)
					props.onChange?.(props.formItem.name, newData)
				}
			},
		});

	}

	const handleSelect = (id: any) => {

		let newData;
		let item = data.find((i: any) => i.id === id)

		if (item.selected) {
			newData = data.map((item: any) => ({...item, selected: false}))

		} else {
			newData = data.map((item: any) => item.id === id ? {...item, selected: true} : {...item, selected: false})
		}

		props.onChange?.(props.formItem.name, newData)
	}

	return (
		<div className={`flex flex-col ${!data.length ? "" : "mb-xl"} `}>
			{!data.length && (
				<div className={`border ${props?.validation ? "border-red-300 bg-red-50 text-red-500" : "border-gray-200 text-gray-400"}  p-md text-text-md rounded-md  select-none`}>
					Font must include at least one style (for example: Regular, Bold, or Italic).
				</div>
			)}
			<DraggableSortList
				items={data}
				onChange={(list)=>{
					props.onChange?.(props.formItem.name, list)
				}}
				renderItem={(item:any, meta)=>
					<div className={"flex flex-row  h-[52px] relative"}>
						<div
							className={
								"flex justify-start items-center  px-md  h-[44px] relative inset-1 flex-1 "+
								"text-text-md text-gray-900 rounded-md border  border-gray-300  hover:border-primary-500  "+
								"cursor-pointer transition-all test-[16px] "+
								`${item.selected === true ?  'shadow-focus border-primary-500 ' : 'shadow-xs'} ` +

								`${meta.phase === "dragging" ? "!border-primary-500" : ""} `+
								`${meta.isDragged  ? "!border-primary-500 shadow-focus !bg-none" : ""} `
							}
							key={item.id}
							onClick={() => handleSelect(item.id)}
						>
							<FontWrapper item={item}>
								{item.name}
							</FontWrapper>
							{meta.phase !== "dragging" &&
								<>
									{item.selected ?
										<span className={'font-icon-solid absolute right-0 w-[35px] h-[35px] justify-center items-center flex text-primary-500'}></span>
									:
										<>{!meta.disabled && <DeleteAbsoluteButton onClick={()=>handleDelete(item)} />}</>
									}
								</>
							}

						</div>
						{!meta.disabled &&
							<div className={`w-[52px] h-[52px] ${(!meta.isDragged && meta.phase !== "idle") ? "!opacity-10" : ""} transition-all text-gray-400 font-icon-regular rounded-md flex justify-center items-center cursor-grab active:cursor-grabbing`}></div>
						}
					</div>
				}
				classNames={{
					over: "bg-primary-100 transition-all rounded-md !max-h-[52px] ",
					list: "gap-0"
				}}
				keyOf={(item:any)=>item.id}
				disabled={hasSelected}

			/>


		</div>
	)
}